export default __webpack_public_path__ + "static/media/person.4f5f6cff.svg";